import { CommonModule } from '@angular/common';
import { Component, input, OnInit } from '@angular/core';
import { VideoPlayerComponent } from '../smart-fix-video-player/smart-fix-video-player.component';

@Component({
  selector: 'app-smart-fix-video-preview',
  standalone: true,
  templateUrl: './smart-fix-video-preview.component.html',
  styleUrls: ['./smart-fix-video-preview.component.scss'],
  imports: [CommonModule, VideoPlayerComponent],
})
export class VideoPreviewComponent implements OnInit {
  messageText = input<string | undefined>('');

  ngOnInit() {
    if (this.messageText) {
      const matches = this.messageText()?.match(
        /((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(?:-nocookie)?\.com|youtu\.be))(\/(?:[\w\-]+\?v=|embed\/|live\/|v\/)?)([\w\-]+)(?:[&?]t=(\d+))?/g
      );
      if (matches?.length) {
        this.videoLinks.push(...matches);
      }
    }
  }

  videoLinks: string[] = [];
}
